import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Box,
  Checkbox,
  Loader,
  MultiSelect,
  Select,
  Slider,
} from "@mantine/core";
import styles from "./style.module.css";
import ads from "../../../assets/home.gif";
import { backendUrl } from "../../../constants";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../components/inputField";
import CompleteProfile from "../../../components/CompleteProfile";
import Button from "../../../components/Button";
import Page from "../../../components/Page";
import JobCard from "./JobCard";
import { showNotification } from "@mantine/notifications";
import { identifier } from "@babel/types";

const Index = ({ documentData, setRefetch }) => {
  const navigate = useNavigate();
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [loc, setLoc] = useState([]);
  const [filters, setFilters] = useState({});
  const [data, setData] = useState({ user: createdBy.id });
  const [loading, setLoading] = useState(false);
  const [appliedJob, setAppliedJob] = useState([]);

  useEffect(() => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(`${backendUrl}job/jobSeekerJobs`, options)
      .then((response) => response.json())
      .then((response) => {
        setAppliedJob(response.data || []);
      });
  }, [data]);

  return (
    <Page className="landing-page">
      <div className={styles.jobMain}>
        <h2 className="text-dark mb-0 mt-2">Job Applications</h2>
        <div className={styles.searchMain}>
          {/* <div className={styles.filters}>
            <div className="">
              <p style={{ margin: "0px", fontWeight: "500" }}>
                Keyword or Name
              </p>
              <InputField
                placeholder="Enter Name"
                className="pr-4"
                style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                onBlur={(v) =>
                  setFilters((filters) => ({
                    ...filters,
                    displayName: v.target.value,
                  }))
                }
              />
            </div>
            <MultiSelect
              label="Jobs"
              placeholder="skills..."
              data={[]}
              searchable
              className="pr-4"
              maxDropdownHeight={400}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
            />
            <MultiSelect
              label="Company"
              placeholder="skills..."
              data={[]}
              searchable
              className="pr-4"
              maxDropdownHeight={400}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
            />
            <Select
              label="Location"
              placeholder="Location..."
              data={loc}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim())
              }
            />
          </div> */}
        </div>
        {loading ? (
          <Loader
            size="xl"
            color="red"
            className="text-center"
            style={{ margin: "auto" }}
          />
        ) : (
          <div className={styles.jobs}>
            {/* <JobCard /> */}
            {appliedJob?.length < 1 ? (
              <h2 className="text-dark text-center">
                You have not applied for any job yet.
              </h2>
            ) : (
              appliedJob?.map((obj, key) => <JobCard data={obj} key={key} />)
            )}
          </div>
        )}
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
